import { ForeignKeyField, RemoteDataSource } from "lego-gui-lib";
import {
  NumberField,
  RangeInc,
  Required,
  Schema,
  TextField
} from "lego-gui-lib/lib";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { withExternalId } from "../../common/common";
import { t } from "../../core/i18n/i18n";
import { api, mainStore } from "../../core/mainStore";
import { Auth } from "../../core/model/auth";
import { CustomerMessagesFK } from "../message/schema";

export const IvrMenuSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "msgRef",
      type: CustomerMessagesFK,
      title: t("hns:message:domain")
    },
    {
      name: "maxAttempts",
      type: NumberField(Required, RangeInc(1, 9)),
      title: t("hns:ivrMenu:max_attempts")
    }
  ]
});

export const EditIvrMenuSchema = IvrMenuSchema.extend({});

mainStore.ivrMenu = RemoteChildDataSource.create({
  parent: mainStore.SAN.oneDataSource,
  dtoStrategy: queryParamDtoStrategy("id", "sanRef"),
  parentChangedStrategy: queryParamParentChangeStrategy("id", "sanRef"),
  api: api,
  name: "ivrMenu",
  schema: IvrMenuSchema,
  url: "/ivrMenus",
  commons: mainStore.commons
});

//workaround for: NO_PARENT_ERROR ¯\_(ツ)_/¯
mainStore.ivrMenuForCopy = RemoteDataSource.create({
  api: api,
  name: "ivrMenu",
  schema: IvrMenuSchema,
  url: "/ivrMenus",
  commons: mainStore.commons
});

mainStore.ivrMenuFk = RemoteChildDataSource.clone(mainStore.ivrMenu);

export const IvrMenuFK = ForeignKeyField(
  {
    dataSource: mainStore.ivrMenuFk.listDataSource,
    labelField: withExternalId(),
    searchField: "name",
    valueField: "id"
  },
  Required
);
